import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgArrow = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 231 176"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="url(#arrow_svg__a)"
      d="M217.621 40.43a1.25 1.25 0 1 1 2.436.558zM94.046 76.033l-.449-1.166zm47.999 58.549-1.107-.582zM7.874 93.432a1.25 1.25 0 0 1 2.301-.975zm220.974-39.301a1.25 1.25 0 1 1-2.201 1.185zm-9.517-15.036-.447-1.167a1.25 1.25 0 0 1 1.548.574zm-16.46 7.256a1.25 1.25 0 1 1-.648-2.414zm15.968-5.642 1.218.28-.001.004-.003.013-.011.047-.043.181q-.056.24-.171.696c-.152.607-.382 1.495-.693 2.626a178 178 0 0 1-2.884 9.386c-2.621 7.786-6.692 18.242-12.492 28.903-11.561 21.256-30.188 43.675-58.189 46.872l-.142-1.242-.142-1.241c26.74-3.054 44.819-24.518 56.277-45.583 5.711-10.5 9.729-20.813 12.319-28.507a175 175 0 0 0 2.843-9.252 111 111 0 0 0 .843-3.24l.04-.17.01-.04.002-.01v-.002zm-73.411 87.766.142 1.242c-27.796 3.175-46.568-8.008-55.581-21.262-4.49-6.603-6.58-13.761-6.068-19.905.515-6.185 3.692-11.378 9.676-13.683l.45 1.166.449 1.166c-4.931 1.9-7.632 6.146-8.083 11.558-.454 5.455 1.401 12.053 5.643 18.292 8.451 12.427 26.285 23.262 53.23 20.185zM94.046 76.033l-.449-1.167c5.816-2.238 13.044-1.819 20.211.513 7.187 2.339 14.445 6.64 20.398 12.36 11.919 11.448 18.754 28.773 8.945 47.425l-1.106-.582-1.107-.582c9.148-17.394 2.898-33.544-8.464-44.459-5.687-5.463-12.619-9.565-19.44-11.784-6.841-2.226-13.44-2.52-18.539-.557zm47.999 58.549 1.106.582c-4.961 9.435-14.444 15.231-26.065 17.729-11.619 2.498-25.49 1.734-39.497-2.033-27.996-7.529-56.883-27.155-69.715-57.428l1.15-.487 1.151-.488c12.46 29.393 40.61 48.606 68.064 55.989 13.717 3.689 27.176 4.399 38.322 2.003 11.144-2.396 19.864-7.864 24.377-16.449zm85.703-79.858-1.101.592-8.416-15.628 1.1-.593 1.101-.593 8.416 15.629zm-8.417-15.63.448 1.168h-.001l-.002.001-.007.003-.029.011-.113.043-.433.166a754 754 0 0 1-6.556 2.466c-3.749 1.39-8.011 2.928-9.767 3.4l-.324-1.208-.324-1.207c1.616-.434 5.746-1.92 9.546-3.33a739 739 0 0 0 6.534-2.457l.43-.165.113-.043.028-.01.008-.003.001-.001h.001z"
    />
    <defs>
      <linearGradient
        id="arrow_svg__a"
        x1={14.198}
        x2={216.93}
        y1={67.332}
        y2={108.281}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5F7C6D" />
        <stop offset={1} stopColor="#007A3D" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgArrow;
